import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { CourseService } from '../../project/course-creation-v2/services/course.service';
import { AuthService } from '../../services/auth/auth.service';
import { RouteEnum } from '../../enums/routes.enum';
import { SectionsEnum } from '../../enums/sections.enum';

/**
 * Blocks editing of assigned courses (except their translations section).
 * Functional replacement for the class-based CourseEditGuard.
 *
 * Improvement enabled by the fixed CourseService.getById: missing courses
 * now return null instead of a phantom empty Course, so a stale or mistyped
 * /course-creation/:id link redirects to the list instead of opening a
 * broken editor.
 */
export const courseEditGuard: CanActivateFn = async (route) => {
	const courseId = route.paramMap.get('id');
	if (!courseId) {
		return true;
	}

	const courseService = inject(CourseService);
	const authService = inject(AuthService);
	const router = inject(Router);

	const courseSection = route.queryParamMap.get('courseSection');
	const course = await courseService.getById(courseId, authService.projectId);

	if (!course) {
		return router.createUrlTree([`/${RouteEnum.COURSE}`]);
	}

	if (course.assigned && courseSection !== SectionsEnum.TRANSLATIONS) {
		return router.createUrlTree([`/${RouteEnum.COURSE}`]);
	}

	return true;
};
